module.exports = __webpack_public_path__ + "img/numeralia_cedis_4.dd838ada.svg";